import React, {useState} from 'react'
import Typography from '@material-ui/core/Typography';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import {makeStyles} from "@material-ui/core";
import Loading from "components/Loading";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import AddContactor from "components/popup/addContactor/AddContactor";
import getObjectValue from "libs/getObjectValue";
import InviteContactor from "components/popup/inviteContactor/InviteContactor";
import Chip from "components/Chip";
import ContractorService from "services/ContractorService";
import DateTimePicker from "components/DateTimePicker";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    inlineBlock: {
        display: 'inline-block',
        marginRight: theme.spacing(2)
    },
    loading: {
        width: '98%'
    },
    buttonRow: {
        textAlign: "end"
    },
    uploadFile: {
        marginBottom: 20
    },
    nameError: {
        fontSize: '0.75rem'
    }
}));

function RegisterEnvelopeForm(
    {
        demandId,
        working,
        error,
        formikProps,
        newEnvelope
    }) {

    const classes = useStyle();
    const [addPopup, setAddPopup] = useState(false);
    const [invitePopup, setInvitePopup] = useState(false);

    const getFormButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('add_contractor'), () => setAddPopup(true), undefined, working));
        buttons.push(createButton(Tr('suggest_contractor'), () => setInvitePopup(true), undefined, working));
        return buttons;
    }

    const getInviteDefaultValues = () => ({
            name: getObjectValue('name', formikProps.values, ''),
            email: getObjectValue('email', formikProps.values, ''),
            postCode: getObjectValue('postCode', formikProps.values, ''),
            city: getObjectValue('city', formikProps.values, ''),
            address: getObjectValue('address', formikProps.values, ''),
            vatin: {
                number: getObjectValue('vatin.number', formikProps.values, ''),
                prefix: getObjectValue('vatin.prefix', formikProps.values, 'PL'),
            }
        }
    )


    const handleClearContractor = () => {

        const values = {
            ...formikProps.values,
            contractorDepartmentId: 0,
            suggestContractor: false,
            contractorName: null,
            name: '',
            email: '',
            postCode: '',
            city: '',
            address: '',
            vatin: {
                number: '',
                prefix: "PL"
            }
        };
        formikProps.setValues(values);
    }

    const handleChipClick = () => {
        if (getObjectValue('suggestContractor', formikProps.values, false)) {
            setInvitePopup(true);
        } else {
            setAddPopup(true);
        }

    }
    const handleAddContractors = (data) => {

        if (data && data.platformAdded.length > 0) {
            ContractorService.getContractorDetails(demandId, data.platformAdded[0]).then((resp) => {
                handleClearContractor();
                formikProps.setFieldValue("contractorDepartmentId", data.platformAdded[0]);
                formikProps.setFieldValue("contractorName", resp.name);
            }).finally(() => setAddPopup(false));
        } else {
            setAddPopup(false);
        }
    }

    const handleInvite = (data) => {
        const values = {
            ...formikProps.values,
            suggestContractor: true,
            contractorDepartmentId: 0,
            contractorName: data.name,
            ...data
        };
        formikProps.setValues(values);
        setInvitePopup(false);
    }

    const contractorName = getObjectValue('contractorName', formikProps.values, false);
    const contractorNameError = getObjectValue('contractorName', formikProps.errors, '');

    return (<GridBlock column>
        {working && <Loading className={classes.loading}/>}

        {newEnvelope && <MultiButton className={classes.margin} buttons={getFormButtons()} justify='space-evenly'/>}

        <div>
            <Typography color={contractorNameError ? 'error' : undefined} className={classes.inlineBlock}>{Tr('offer_supplier')}*:</Typography>
            {!!contractorName && <Chip value={contractorName} onDelete={!newEnvelope || working ? undefined : handleClearContractor}
                                       onClick={!newEnvelope || working ? undefined : handleChipClick}/>}
            {!!contractorNameError && <Typography color='error' className={classes.nameError}>{contractorNameError}</Typography>}
        </div>

        {error && <Typography color='error'>{error}</Typography>}

        <DateTimePicker
            label={Tr("offer_date")}
            formikProps={formikProps}
            id="offerDate"
            required
            //onChange={onChange}
            maxDate={new Date()}
            disabled={working}
        />


        {addPopup && <AddContactor
            demandId={demandId}
            onClose={() => setAddPopup(false)}
            addContractorsTab={handleAddContractors}
        />}

        {invitePopup && <InviteContactor
            demandId={demandId}
            open
            onClose={() => setInvitePopup(false)}
            handleInvite={handleInvite}
            defaultValues={getInviteDefaultValues()}
            collectPostCode
            collectAddress
            collectCity
        />}

    </GridBlock>)
}

export default RegisterEnvelopeForm;